export const HONORARIOS_TITLE = 'Honorários (HB)';
export const TIPO_CALCULO_LABEL = ' Tipo de cálculo para os Honorários em uso na ABE';
export const RANGE_LABEL = 'Adicionar Faixa de Honorários por ';
export const RANGE_QUERY_LABEL = 'Faixa de Honorários por ';
export const ADD_RANGE_HINT = 'Adicionar Faixa';
export const TAXA_HONORARIO_FASE_TITLE = 'Taxa Mínima de Honorários por Fase';
